import { useParams } from 'react-router-dom';
import { Asset } from '../../queries/ats/titles/types/asset';
import { Source } from '../../queries/ats/titles/types/sources';
import { Sources } from '../../queries/ats/titles/utils/sources-utils';
import { AvailableContext } from './use-available-contexts';
import { InputContext } from './use-input-context';

function firstAvailableSource<T extends Source[]>(...arr: Sources<T>[]): Source {
  return arr.reduce((prev, curr) => (prev.size > 0 ? prev : curr)).first;
}

export function getPreferredSource(sourcesInput: Source[], context: AvailableContext, inputContext: InputContext) {
  const contextSources = context.sources(sourcesInput);
  const sources = new Sources(contextSources).byInputContext(inputContext);
  const initialSources = new Sources(sourcesInput);

  switch (context.type) {
    case 'tv':
      return firstAvailableSource(
        sources.live(),
        sources
          .recorded()
          .bookmarked()
          .closest((x) => x.bookmark.dateTime),
        sources.recorded(),
        sources
          .programs()
          .bookmarked()
          .closest((x) => x.bookmark.dateTime),
        sources
          .programs()
          .closest((x) => x.startTime)
          .playable(),
        sources.programs().playable(),
        sources,
        initialSources,
      );
    case 'vod':
      return firstAvailableSource(
        sources
          .vod()
          .playable()
          .bookmarked()
          .closest((x) => x.bookmark.dateTime),
        sources.vod().playable(),
        sources,
        initialSources,
      );
    case 'svod':
      return firstAvailableSource(
        sources
          .svod()
          .playable()
          .bookmarked()
          .closest((x) => x.bookmark.dateTime),
        sources.svod().playable(),
        sources,
        initialSources,
      );
    case 'thirdparty':
      return firstAvailableSource(
        sources
          .thirdparty()
          .bookmarked()
          .closest((x) => x.bookmark.dateTime),
        sources.thirdparty().playable(),
        sources,
        initialSources,
      );
    default:
      return sources.first;
  }
}

export function appendSequenceNumbers(str: string, asset: Asset): string {
  if (asset.type !== 'episode') {
    return str;
  }

  return `${str} S${asset.season.sequenceNumber} • E${asset.episode.sequenceNumber}`;
}

export interface DetailsParams {
  id: string;
  type: Asset['type'] | 'recording';
  subType?: 'series' | 'single';
}

export function useDetailsParams() {
  return useParams<DetailsParams>();
}
